import React from "react";
import CheapestCarCard from "./CheapestCarCard";
import { Swiper, SwiperSlide } from "swiper/react";

type Props = {};

const MobilePlaceholder = (props: Props) => {
  return (
    <Swiper
      slidesPerView={1.1}
      spaceBetween={16}
      className="w-full h-full mySwiper"
    >
      {loadData.map((data) => (
        <SwiperSlide key={data.id} className="w-full rounded-2xl">
          <CheapestCarCard
            key={data.id}
            carImg={data.carImg}
            luggage={""}
            size={data.size}
            name={data.name}
            passengers={data.passengers}
            doors={""}
            cost={data.totalPrice}
            airconditioning={data.airconditioning}
            data={data}
            providerLogo={data.providerLogo}
            totalPrice={data.totalPrice}
            sites={0}
            bookUrl={data.bookUrl}
            policies={data.policies}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const loadData = [
  {
    id: "1",
    carImg: "/drive-around-cars/economy.png",
    luggage: "2",
    size: "Economy",
    name: "Similar Economy Car",
    passengers: 4,
    doors: "4",
    cost: "loading",
    airconditioning: true,
    data: "loading",
    providerLogo: "loading",
    totalPrice: "loading",
    sites: "loading",
    bookUrl: "loading",
    policies: [
      {
        value: "FUEL",
        valueDisplay: "Fair Fuel Policy",
      },
      {
        value: "BESTPRICE",
        valueDisplay: "Best Price",
      },
    ],
  },
  {
    id: "2",
    carImg: "/drive-around-cars/small.png",
    luggage: "2",
    size: "Small",
    name: "Similar Small Car",
    passengers: 4,
    doors: "4",
    cost: "loading",
    airconditioning: true,
    data: "loading",
    providerLogo: "loading",
    totalPrice: "loading",
    sites: "loading",
    bookUrl: "loading",
    policies: [
      {
        value: "FUEL",
        valueDisplay: "Fair Fuel Policy",
      },
      {
        value: "BESTPRICE",
        valueDisplay: "Best Price",
      },
    ],
  },
  {
    id: "3",
    carImg: "/drive-around-cars/suv.png",
    luggage: "2",
    size: "SUV",
    name: "Similar SUV",
    passengers: 5,
    doors: "4",
    cost: "loading",
    airconditioning: true,
    data: "loading",
    providerLogo: "loading",
    totalPrice: "loading",
    sites: "loading",
    bookUrl: "loading",
    policies: [
      {
        value: "FUEL",
        valueDisplay: "Fair Fuel Policy",
      },
      {
        value: "BESTPRICE",
        valueDisplay: "Best Price",
      },
    ],
  },
  {
    id: "4",
    carImg: "/drive-around-cars/lux.png",
    luggage: "2",
    size: "Luxury",
    name: "Similar Luxury Car",
    passengers: 4,
    doors: "4",
    cost: "loading",
    airconditioning: true,
    data: "loading",
    providerLogo: "loading",
    totalPrice: "loading",
    sites: "loading",
    bookUrl: "loading",
    policies: [
      {
        value: "FUEL",
        valueDisplay: "Fair Fuel Policy",
      },
      {
        value: "BESTPRICE",
        valueDisplay: "Best Price",
      },
    ],
  },
];

export default MobilePlaceholder;
